<template>
  <div id="AddCourseDialog" v-if="semester" class="wrap">
    <v-app-bar extended extension-height="10" class="grey lighten-3 hidden-md-and-up"  fixed  elevate-on-scroll  >
      <v-layout column align-center class="justify-center">
        <span class="title light-blue--text text--darken-3 text-center">Add Course</span>
        <v-layout row align-baseline class=" ">

            <span class="subheading ">{{semester.semester_academic_status}} Year </span>
            <span class=" subheading ml-1  ">{{semester.semester_term}}</span>
            <span class=" ml-1  ">{{semester.semester_year | moment("YYYY")}}</span>
          </v-layout>
      </v-layout>
    </v-app-bar>
    <div class="maxContainer">
       <div class="offset-md-3 col-md-6 offset-sm-2 col-sm-8">
        <div @click="back" class="headerFake__back">
          <a class="headerFake__backLink">
            <v-icon class="mr-3" medium color="red">mdi-arrow-left</v-icon>
            <span class="headerFake__backText">Back</span>
          </a>
        </div>
      </div>
    <v-card class=" mb-5 pt-5 offset-md-3 col-md-6 offset-sm-2 col-sm-8" flat  >
      <v-card-text class="mt-0 pt-0 px-0">
        <v-container grid-list-md pt-0 >

          <v-form>
            <!-- Desktop Title Header -->
            <v-layout column align-center class="justify-center hidden-sm-and-down mb-3">
              <span class="headline light-blue--text text--darken-3 text-center">Add Course</span>
              <v-layout row align-baseline class=" ">

                  <span class="subheading ">{{semester.semester_academic_status}} Year </span>
                  <span class=" subheading ml-1  ">{{semester.semester_term}}</span>
                  <span class=" ml-1  ">{{semester.semester_year | moment("YYYY")}}</span>
                </v-layout>
            </v-layout>

            <!-- Select Course -->
            <v-flex xs12>
              <v-autocomplete
                v-model="course_id"
                :items="courses"
                item-text= "course_name"
                hide-selected
                item-value="id"
                label="Select Course"
                color="green"
                clearable
                outlined

                hide-details
                >

              </v-autocomplete>
            </v-flex>

            <!-- Course Grade -->
            <v-flex xs12 v-if="semester.semester_completion_status === 'Completed' " >
              <v-autocomplete
                v-model="course_grade"
                class="mt-4 pt-0"
                :items="['A+', 'A', 'A-', 'AB', 'B+', 'B', 'B-', 'BC', 'C+', 'C', 'C-', 'CD', 'D+', 'D', 'D-', 'F', 'W']"
                label="Course Grade"
                color="green"
                clearable
                outlined

                hide-details
                :disabled="pass_fail_course === true"
              ></v-autocomplete>
            </v-flex>

            <!-- Course Credits -->
            <v-flex xs12 class="mt-7" v-if="college.college_term_system === 'Semester' || college.college_term_system === 'Trimester' ">
              <v-text-field
                class="mt-7 pt-0"
                v-model="course_credits"
                label="Course Credits"
                required
                color="green"
                outlined

                hide-details
              ></v-text-field>
            </v-flex>

            <!-- Quarter Credits -->
            <v-flex xs12 class="mt-7" v-if="college.college_term_system === 'Quarter'">
              <v-text-field
                class="mt-4 pt-0"
                v-model="quarter_credits"
                label="Quarter Credits"
                required
                color="green"
                outlined

                hide-details
              ></v-text-field>
            </v-flex>

            <!-- With or Without Lab -->
            <v-flex xs12 class="mt-7">

              <v-radio-group v-model="course_lab" row class="mt-0 mb-0 mt-4 ml-2"  hide-details>

                <v-radio
                  label="with lab"
                  value='true'
                  color="green"
                ></v-radio>
                <v-radio
                  label="without lab"
                  value=false
                  color="green"
                ></v-radio>
              </v-radio-group>


            </v-flex>

            <v-flex xs12 v-if="course_lab === 'true'"  mt-7  mb-2 >
              <v-autocomplete
                v-if="semester.semester_completion_status === 'Completed' "
                v-model="lab_grade"
                class="mt-5 pt-0"
                :items="['A+', 'A', 'A-', 'AB', 'B+', 'B', 'B-', 'BC', 'C+', 'C', 'C-', 'CD', 'D+', 'D', 'D-', 'F', 'W']"
                label="Lab Grade"
                 persistent-hint
                 hint="Leave blank if lab grade included with course"
                color="green"
                clearable
                outlined

                :disabled="pass_fail_course === true"
              ></v-autocomplete>
               <v-text-field
                v-if="college.college_term_system === 'Semester' || college.college_term_system === 'Trimester'"
                class=" mt-3 pt-0"
                v-model="lab_credits"
                label="Lab Credits"
                required
                color="green"
                outlined

                persistent-hint
                 hint="Leave blank if lab credits included with course"
              ></v-text-field>

              <v-text-field
                v-if="college.college_term_system === 'Quarter'"
                class=" mt-3 pt-0"
                v-model="lab_quarter_credits"
                label="Lab Quarter Credits"
                required
                color="green"
                outlined

                persistent-hint
                 hint="Leave blank if lab credits included with course"
              ></v-text-field>


            </v-flex>


<!--
            <v-flex xs12>
              <v-text-field
                class="mt-4 pt-0"
                v-model="course_credits"
                label="Course Credits"
                required
                color="green"
              ></v-text-field>
            </v-flex> -->
<!--
            <v-flex xs12 v-if="semester.semester_completion_status === 'Completed' ">
              <v-autocomplete
                v-model="course_grade"
                class="mt-2 pt-0"
                :items="['A+', 'A', 'A-', 'B+', 'B', 'B-', 'C+', 'C', 'C-', 'D+', 'D', 'D-', 'F', 'W']"
                label="Course Grade"
                color="green"
                clearable
                :disabled="pass_fail_course === true"
              ></v-autocomplete>
            </v-flex> -->

           <v-card outlined class="px-3 py-2 mt-7">
              <v-flex xs12  mt-0 align-center mb-2 >
                  <v-checkbox v-model="online_course" class="mt-1 shrink" color="green" value="true" hide-details label="Online Course"></v-checkbox>
              </v-flex>
              <v-flex xs12 v-if="online_course && course_lab !== 'false' " column mt-0 ml-3 mb-2>
                  <v-checkbox v-model="online_lab" class="mt-1 shrink" color="green" value="labOnline" hide-details label="Lab Component Online"></v-checkbox>
                  <v-checkbox v-model="online_lab" class="mt-1  shrink" color="green" value="labInPerson" hide-details label="Lab Component In Person" ></v-checkbox>
              </v-flex>
              <v-flex xs12  mt-0 align-center mb-2 >
                <v-checkbox v-model="pass_fail_course" class="mt-1 shrink" color="green" hide-details label="Pass/Fail Course"></v-checkbox>
              </v-flex>

              <v-flex xs12 v-if="pass_fail_course && semester.semester_completion_status === 'Completed'"  mt-0 align-center mb-2 ml-3>
                <v-checkbox v-model="pass_fail_grade" class="mt-1 shrink" color="green" value="true" hide-details label="Pass"></v-checkbox>
                <v-checkbox v-model="pass_fail_grade" class="mt-1 ml-3 shrink" color="green" value="false" hide-details label="Fail" ></v-checkbox>
              </v-flex>
           </v-card>


          </v-form>
          <!-- Add Course Button -->
          <v-layout column justify-center align-center style="marginBottom:50px">

            <v-btn
              class="mt-4"

              color="green"
              @click="addCourse"
              block

              large
              depressed
              :disabled="checkAddCourse"
            >

              <span class="white--text"> Add Course</span>
            </v-btn>

              <a  @click="addCustomCourseDialog = true; dontSeeCourseDialog = false;" class="mt-3 subtitle-1" style="textDecoration: underline"><span > Add Custom Course</span></a>



          </v-layout>
        </v-container>
       </v-card-text>
    </v-card>

    <v-dialog
      scrollable
      width="500"
      class="dialog"
      persistent
      style="borderRadius:10px;"
      v-model="addCustomCourseDialog"
    >
      <add-custom-course @cancel="closeCustomCourseDialog" />
    </v-dialog>
    <v-dialog
      v-model="dontSeeCourseDialog"
      scrollable
      width="500"
      class="dialog"
      style="borderRadius:10px;"
      persistent
      >





      <v-card  style="borderRadius:5px;">
          <v-toolbar card color="amber darken-2" dark flat>
            <v-toolbar-title>Add you </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-icon @click="dontSeeCourseDialog = false">mdi-close</v-icon>
          </v-toolbar>

          <v-card-text>
          If you do not see your course in the course list, send us an email with the course information and we will add it.
          </v-card-text>







              <v-layout justify-center class="mx-2">

                <v-btn
                  href="mailto:data@mypabox.com"
                  color="blue"
                  dark
                  class="mb-3 elevation-0 "
                  block
                >
                <v-icon small class="mr-1">mdi-email</v-icon>
                Email

                </v-btn>
              </v-layout>

              <v-layout justify-center class="mx-2">

                <v-btn
                  color="blue"
                  dark
                  class="mb-3 elevation-0 "
                  block
                  @click="addCustomCourseDialog = true; dontSeeCourseDialog = false;"
                >
                Add Custom Course
                </v-btn>
              </v-layout>



      </v-card>
  </v-dialog>
</div>

    <!-- Back Button -->
     <v-btn  class="mr-4 ml-2  fixed elevation-0" color="red"  fab rounded small @click="back"> <v-icon  medium color="white">mdi-arrow-left</v-icon></v-btn>



  </div>

</template>

<script>
  import AddCustomCourse from '@/components/Dashboard/Grades/Courses/AddCustomCourse.vue'
  import { mapGetters } from 'vuex'
  export default {
    components: {
      AddCustomCourse
    },
     data() {
      return {
        modal: false,
        alert: false,
        AddCourseDialog : false,
        dontSeeCourseDialog: false,
        course_id : '',
        course_semester: '',
        course_lab: '',
        lab_credits: '',
        lab_grade: '',
        course_credits: '',
        quarter_credits: '',
        lab_quarter_credits: '',
        course_grade: '',
        online_course: '',
        pass_fail_course: '',
        pass_fail_grade: '',
        online_lab: '',
        newCollegeId: null,
        newSemesterId: null,
        addCustomCourseDialog: false
      }
    },
    methods: {
      closeCustomCourseDialog (courseId = null) {
        this.addCustomCourseDialog = false
        if (courseId) {
          this.course_id = courseId
        }
      },
      back() {
        this.$router.go(-1)
      },
      addCourse () {
        var course_gpa_calculation = ''
        var course_subject_category = ''
        var name = ''

        for (var c = 0; c < this.courses.length; c++) {
          if(this.courses[c].id === this.course_id ) {
             course_gpa_calculation = this.courses[c].course_gpa_calculation
             course_subject_category = this.courses[c].course_subject_category
             name = this.courses[c].course_name
          }
        }


        const courseData = {

          ...this.$route.params,
          course_id : this.course_id,
          course_name : name,
          course_lab: this.course_lab,
          course_credits: this.course_credits,
          quarter_credits: this.quarter_credits,
          lab_quarter_credits: this.lab_quarter_credits,
          course_grade: this.course_grade,
          online_course: this.online_course,
          pass_fail_course: this.pass_fail_course,
          pass_fail_grade: this.pass_fail_grade,
          online_lab: this.online_lab,
          lab_credits: this.lab_credits,
          lab_grade: this.lab_grade,
          course_gpa_calculation : course_gpa_calculation,
          course_subject_category: course_subject_category,
        }
        console.log(courseData, this.$route.params)
        this.$store.dispatch('setUserCourse', courseData)
        this.$router.go(-1)

        this.course_id = '',
        this.course_semester = '',
        this.course_lab = '',
        // this.course_credits = '',
        this.course_grade = '',
        this.online_course = '',
        this.pass_fail_course = '',
        this.pass_fail_grade = '',
        // this.quarter_credits = '',
        this.lab_quarter_credits = '',
        this.lab_credits = '',
        this.lab_grade = ''


      }
    },
    computed : {
      ...mapGetters(['userCustomCourses']),
      collegeId () {
        return this.$route.params.collegeId
      },
      semesterId () {
        return this.$route.params.semesterId
      },
      user () {
        return this.$store.getters.user
      },
      college() {
        // return this.$store.getters.loadedCollege(this.collegeId);
        if(this.$store.getters.loadedCollege) {
          return this.$store.getters.loadedCollege(this.$route.params.collegeId)
        }

      },
      semester() {
          // return this.$store.getters.loadedSemester(this.newCollegeId, this.newSemesterId)
          if(this.college) {
             return this.college.semesters.find((semester) => {
            return semester.id === this.$route.params.semesterId
          })
          }

     },


      checkAddCourse () {
        console.log('this.semester.semester_completion_status',this.semester.semester_completion_status)
        const isInProgress = this.semester.semester_completion_status === 'In Progress' || this.semester.semester_completion_status === 'Planned'
        const isSemesterCompleted = isInProgress ? true : this.semester.semester_completion_status === 'Completed' && this.course_grade !== '' 
        let isHasLab = !isInProgress ? false : true

        if (!isInProgress && this.course_lab && this.lab_credits == '' && this.lab_grade == '' || !isInProgress && this.course_lab && this.lab_credits == '' && this.lab_grade === undefined) {
          isHasLab = true
        } else if (!isInProgress && this.course_lab && this.lab_grade && this.lab_grade.length > 0 && !isInProgress && this.course_lab && this.lab_credits.length > 0) {
          isHasLab = true
        } else if (!isInProgress && this.course_lab && this.lab_grade !== '' || !isInProgress && this.course_lab && this.lab_credits !== '' || !isInProgress && this.course_lab && this.lab_grade !== '') {
          isHasLab = false
        }

        if( isHasLab && isSemesterCompleted && this.course_id !== '' && this.course_credits !== '' && this.course_lab !== '' || this.quarter_credits !== '' ){
          return false
        } else {
          return true
        }

      },
      userColleges () {
        return this.$store.getters.userColleges
      },
      schools() {
        return this.$store.getters.loadedSchools
      },
      courses() {
        return this.userCustomCourses.concat(this.$store.getters.loadedCourses)
      }

    },
  }
</script>

<style scoped>
  #headerToolbar {
    position: sticky;
    box-shadow: 0 10px 30px -10px #11111130;
  }
   .fixed {
    position: fixed;
    bottom: 0;
    right: 0;
    margin-bottom:65px;

  }
.maxContainer {
  max-width: 1280px;
  margin: 0 auto;
}

.headerFake__back {
  text-align: left;
  position: relative;
  display: none;

}
.headerFake__backLink {
  cursor: pointer;
}
.headerFake__backText {
  position: absolute;
  top: 0;
  left: 32px;
  line-height: 26px;
  color: initial;
}

@media (min-width: 960px) {
  .headerFake__back {
    display: block;
  }
  .fixed {
    display: none;
  }
}

.wrap {
    margin-top: 8vh !important;
    
  }

</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Grades/Courses/AddCourseDialog.vue